import { __assign, __extends, __rest } from "tslib";
import React, { Component } from 'react';
import { PoseGroup } from 'react-pose';
import { Cover, Container, PopoverElement } from './styles';
import Position from '../Position';
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        _this.toggleVisibility = function () {
            _this.setState(function (state) { return ({ isVisible: !state.isVisible }); });
        };
        _this.onMouseOver = function () {
            _this.setState({ isVisible: true });
        };
        _this.onMouseOut = function () {
            _this.setState({ isVisible: false });
        };
        return _this;
    }
    Popover.prototype.render = function () {
        var _a = this.props, _b = _a.align, align = _b === void 0 ? 'center' : _b, _c = _a.animateOnMount, animateOnMount = _c === void 0 ? true : _c, _d = _a.boxShadow, boxShadow = _d === void 0 ? 'popover.default' : _d, children = _a.children, _e = _a.distance, distance = _e === void 0 ? 15 : _e, isActive = _a.isActive, _f = _a.position, position = _f === void 0 ? 'top' : _f, _g = _a.showOn, showOn = _g === void 0 ? 'click' : _g, zIndex = _a.zIndex, rest = __rest(_a, ["align", "animateOnMount", "boxShadow", "children", "distance", "isActive", "position", "showOn", "zIndex"]);
        var isVisible = showOn === 'custom' ? isActive : this.state.isVisible;
        var hoverProps = showOn === 'hover' && {
            onMouseLeave: this.onMouseOut,
            onMouseEnter: this.onMouseOver,
        };
        var clickProps = showOn === 'click' && {
            onClick: this.toggleVisibility,
        };
        /* PoseGroup animates all children in based on components with transitions
         * created in styles.js. Each one needs a unique key prop! */
        return (React.createElement(Position, __assign({ position: showOn === 'custom' ? 'unset' : 'relative', width: 1, zIndex: zIndex }, hoverProps),
            showOn !== 'custom' && React.createElement("span", __assign({}, clickProps), children[0]),
            React.createElement(PoseGroup, { animateOnMount: animateOnMount }, isVisible && (React.createElement(Container, { key: "popoverElement", y: position === 'top' ? '10%' : '-10%' },
                React.createElement(PopoverElement, __assign({ align: align, bg: "white", borderRadius: 2, boxShadow: boxShadow, distance: distance, position: position }, rest),
                    showOn !== 'custom' ? children[1] : children,
                    React.createElement(Cover, { distance: distance, position: position })))))));
    };
    return Popover;
}(Component));
export default Popover;
